// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2WYz1","choiceBoxes":"toolbarselects_choiceBoxes__28awJ","simpleField":"toolbarselects_simpleField__3IDQD"};